module.exports = __webpack_public_path__ + "img/frontend_base_hospitalar.e86cc312.jpg";